"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const checkbox_1 = __importDefault(require("@kyruus/checkbox"));
const prop_types_1 = require("prop-types");
const react_1 = __importDefault(require("react"));
const Location_utils_1 = require("../Locations/Location.utils");
const styles_1 = require("../Locations/styles");
const DropdownBookableLocation = (_a) => {
    var { id, name, disabled, isSelected, onSelect } = _a, props = __rest(_a, ["id", "name", "disabled", "isSelected", "onSelect"]);
    return (react_1.default.createElement(styles_1.BookableLocationContainer, { disabled: disabled, className: "BookableLocation", "data-testid": props['data-testid'] || 'ProviderLocations__Location' },
        react_1.default.createElement(checkbox_1.default, { disabled: disabled, checked: isSelected, name: id, hasError: false, label: name, onChange: () => !disabled && onSelect(id) },
            react_1.default.createElement("div", null,
                react_1.default.createElement(Location_utils_1.Name, null, name),
                props.children))));
};
DropdownBookableLocation.propTypes = {
    id: prop_types_1.string.isRequired,
    name: prop_types_1.string.isRequired,
    isSelected: prop_types_1.bool.isRequired,
    onSelect: prop_types_1.func.isRequired,
    disabled: prop_types_1.bool.isRequired,
    street1: prop_types_1.string,
    street2: prop_types_1.string,
    suite: prop_types_1.string,
    city: prop_types_1.string,
    state: prop_types_1.string,
    zip: prop_types_1.string,
    'data-testid': prop_types_1.string,
    children: prop_types_1.object
};
exports.default = DropdownBookableLocation;
//# sourceMappingURL=DropdownBookableLocation.js.map